import { render, staticRenderFns } from "./pos-employee-emp-custody.vue?vue&type=template&id=01723e96"
import script from "./pos-employee-emp-custody.vue?vue&type=script&lang=js"
export * from "./pos-employee-emp-custody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports